export enum EmployeeSituation {
  WORKING = "1. Trabalhando",
  VACATION = "2. Férias",
  SICK_LEAVE = "3. Auxílio Doença",
  MATERNITY_LEAVE = "6. Licença Maternidade",
  DISMISSED = "7. Demitido",
  PAID_LEAVE = "10. Lic. Rem. p/ Funcion.",
  DISABILITY_RETIREMENT = "122. Aposentadoria p/ Invalidez",
}
